
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'Price'
})
export default class extends Vue {
  @Prop({ default: '' }) private price!: string;

  @Prop({ default: 'small' }) private size!: string;
}
